<template>
    <div class="modal fade" id="dueDateCreateOrderModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-lg">
            <div class="modal-content bg-white">
                <template v-if="!enggDocReady">
                    <div class="modal-header">
                        <h5 class="modal-title">Engineer Document Ready?</h5>
                    </div>
                    <div class="modal-body">
                        <p class="text-center">Engineer Document Ready?</p>
                        <div class="d-flex justify-content-center">
                            <button class="btn btn-danger" @click="enggDocReady = false; hideModal()">No, Cancel</button>
                            <button class="btn btn-theme ms-2" @click="enggDocReady = true">Yes, Ready</button>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="modal-header">
                        <h5 class="modal-title">Task Assign To</h5>
                    </div>
                    <div class="modal-body">
                        <form class="row g-3">
                            <div class="col-md-4">
                                <label for="customer_name" class="form-label">Client Name</label>
                                <input
                                    type="text"
                                    class="form-control disabled"
                                    id="customer_name"
                                    disabled
                                    v-model="orderData.customer.name"
                                />
                            </div>
                            <div class="col-md-4">
                                <label for="phone_number" class="form-label">Mobile Number</label>
                                <input
                                    type="text"
                                    class="form-control disabled"
                                    id="phone_number"
                                    disabled
                                    v-model="orderData.customer.phone_number"
                                />
                            </div>
                            <div class="col-md-4">
                                <label for="email" class="form-label">Email</label>
                                <input
                                    type="text"
                                    class="form-control disabled"
                                    id="email"
                                    disabled
                                    v-model="orderData.customer.email"
                                />
                            </div>
                            <div class="col-md-12">
                                <label for="email" class="form-label">Address</label>
                                <textarea
                                    class="form-control disabled"
                                    id="email"
                                    rows="1"
                                    disabled
                                    v-model="orderData.address.full_address"
                                ></textarea>
                            </div>
                            <hr/>
                            <div class="col-md-6">
                                <label for="assign_date" class="form-label">Assign Date <span class="text-danger">*</span></label>
                                <VueDatePicker
                                    name="assign_date"
                                    v-model="orderData.booking_date"
                                    :format="'dd-MM-yyyy'"
                                    :enable-time-picker="false"
                                    :display-marker="false"
                                    :clearable="false"
                                    :timezone="'UTC'"
                                    :min-date="new Date()"
                                    :auto-apply="true"
                                ></VueDatePicker>
                            </div>
                            <div class="col-md-6">
                                <label for="assign_date" class="form-label">Assign Time <span class="text-danger">*</span></label>
                                <VueDatePicker
                                    name="assign_time"
                                    v-model="orderData.booking_time"
                                    time-picker :is-24="false"
                                    :clearable="false"
                                    :minutes-grid-increment="10"
                                    :minutes-increment="15"
                                >
                                    <template #input-icon>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clock-11 hm-time-icons"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 9.5 8"/></svg>
                                    </template>
                                </VueDatePicker>
                            </div>
                            <div class="col-md-6">
                                <div class="form-check form-check-inline mb-0">
                                    <input
                                        class="form-check-input"
                                        type="radio"
                                        name="assign_duration"
                                        id="hours"
                                        value="hours"
                                        v-model="orderData.assigned_duration_type"
                                    >
                                    <label class="form-check-label" for="hours">Time Duration (In Hours)</label>
                                </div>
                                <div class="form-check form-check-inline mb-0">
                                    <input
                                        class="form-check-input"
                                        type="radio"
                                        name="assign_duration"
                                        id="full_day"
                                        value="full_day"
                                        v-model="orderData.assigned_duration_type"
                                    >
                                    <label class="form-check-label" for="full_day">Full Day</label>
                                </div>
                                <input
                                    type="number"
                                    class="form-control"
                                    id="assign_duration"
                                    :class="{'disabled': orderData.assigned_duration_type === 'full_day'}"
                                    :disabled="orderData.assigned_duration_type === 'full_day'"
                                    v-model="orderData.assigned_duration"
                                />
                            </div>
                            <div class="col-md-6">
                                <label for="assign_handyman" class="form-label">Task Assign To <span class="text-danger">*</span></label>
                                <VueSelect
                                    v-model="orderData.handyman_id"
                                    :items="handymanList"
                                    :multiple="true"
                                    :placeholder="'Select Handyman'"
                                    @onSelectOption="onSelectHandyman"
                                ></VueSelect>
                                <small v-if="handymanList.length === 0" class="text-danger">Please select valid assign date and time for task.</small>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button 
                            type="button"
                            class="btn btn-sm btn-outline-danger"
                            data-bs-dismiss="modal"
                            @click="hideModal"
                        >Cancel</button>
                        <button
                            type="button"
                            class="btn btn-theme btn-sm"
                            v-text="processing ? 'Loading...' : 'Assign Task'"
                            @click="createAndAssignOrder"
                        ></button>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import { appMixin } from '../../mixin/appMixin';
import VueSelect from "../partials/VueSelect";

export default {
    name: "DueDateCreateOrder",
    mixins: [appMixin],
    components: {
        VueSelect
    },
    props: {
        order: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            enggDocReady: false,
            processing: false,
            orderData: {
                id: '',
                service_id: '',
                customer_id: '',
                address_id: '',
                booking_date: new Date(),
                booking_time: { hours: '07', minutes: '00' },
                assigned_duration: 2,
                assigned_duration_type: 'hours',
                handyman_id: [],
                customer: {
                    name: '',
                    phone_number: '',
                    email: '',
                    address: '',
                },
                service: {
                    id: '',
                    name: '',
                },
                address: {
                    id: '',
                    address: '',
                    address_1: '',
                    address_2: '',
                    full_address: '',
                    postal_code: '',
                }
            },
            handymanList: [],
        };
    },
    mounted() {
        // Check if this.order is not empty
        if (Object.keys(this.order).length > 0) {
            this.orderData.id = this.order.id;
            this.orderData.service_id = this.order.service_id;
            this.orderData.customer_id = this.order.customer_id;
            this.orderData.address_id = this.order.address_id;
            this.orderData.customer = this.order.customer;
            this.orderData.service = this.order.service;
            this.orderData.address = this.order.address;
            this.orderData.booking_date = this.momentObj(this.order.due_date);
            this.orderData.booking_time = { hours: '07', minutes: '00' };
        }
    },
    watch: {
        'orderData.booking_date': function(oldVal, newVal) {
            this.getHandymanAvailable();
        },
        'orderData.booking_time': function(oldVal, newVal) {
            this.getHandymanAvailable();
        },
        'orderData.assigned_duration_type': function(newVal) {
            if (newVal === 'full_day') {
                this.orderData.assigned_duration = 8;
            } else {
                this.orderData.assigned_duration = 2;
            }
        }
    },
    methods: {
        showModal() {
            $('#dueDateCreateOrderModal').modal('show');
        },
        hideModal() {
            $('#dueDateCreateOrderModal').modal('hide');
            // Emit an event to reset the selected order
            this.$emitter.emit('reset-selected-order');
        },
        async getHandymanAvailable() {
            let params = {
                order_id: this.orderData.id,
                booking_date: this.orderData.booking_date,
                start_time: this.orderData.booking_time,
                end_time: {
                    hours: this.padZero(parseInt(this.orderData.booking_time.hours) + parseInt(this.orderData.assigned_duration)),
                    minutes: this.orderData.booking_time.minutes
                },
            };
            let users = await this.getHandymanForTaskAssignment(params);

            //Check if user is empty then empty the handyman_ids
            if (users.length == 0) {
                this.orderData.handyman_id = [];
            }
            //Prepare the options
            this.handymanList = users.map(user => ({
                id: user.id,
                text: user.name,
                name: user.name,
                email: user.email,
                temporary_booked: user.temporary_booked
            }));
        },
        onSelectHandyman(event) {
            // Check if temporary_booked is true then show alert
            if (event.temporary_booked) {
                Swal.fire({
                    text: `${event.name} is temporary booked for another task, are you sure you want to assign this task to ${event.name}?`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, assign it!',
                    reverseButtons: true
                }).then((result) => {
                    if (!result.isConfirmed) {
                        // Then remove the id from the updateOrderData.handyman_id
                        this.orderData.handyman_id = this.orderData.handyman_id.filter(id => id !== event.id);
                    }
                });
            }
        },
        createAndAssignOrder() {
            if(typeof this.orderData.handyman_id === 'undefined' || this.orderData.handyman_id.length === 0) {
                this.$notification('error', "Please assign at-least one handyman to the order.");
                return;
            }
            this.processing = true;

            axios
                .post("/admin/orders/create-and-assign", this.orderData)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.enggDocReady = false;
                        this.isLoading = false;
                        this.hideModal();

                        // Trigger event to parent component order is created
                        this.$emitter.emit('due-date-order-created', response.data.order);
                    }
                    this.$notification(response.data.status, response.data.message);
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    }
};
</script>